export default __webpack_public_path__ + "media/Livelihood.13d2866c.svg";